export default __webpack_public_path__ + "static/media/2.2ee4a4f8.png";